// @flow
import {getPlaceIdApi} from '../../api';
import {MapGeocodeServices} from '../MapServices';

import type {LatLng} from '../MapServices';
import type {AddressGeo as Location} from '../../../../entities';

type LocationGeo = {
  placeId: string,
  location: LatLng,
  addressComponents: any[],
};
export class GoogleMapsGeocodeServices implements MapGeocodeServices {
  geocoder: ?any;
  sessionToken: ?any;

  constructor(provider: any) {
    this.geocoder = new provider.maps.Geocoder();
    this.sessionToken = new provider.maps.places.AutocompleteSessionToken();
  }

  getGeoCode = async ({location}: {location: LatLng}): Promise<any> => {
    if (this.geocoder) {
      const response = await this.geocoder.geocode({location});

      if (response.results && response.results.length > 0) {
        const results = response.results;
        const loc = results[0].geometry.location;
        const newLoc: ?Location = this.getGoogleMapsData({
          location: {
            lat: loc.lat(),
            lng: loc.lng(),
          },
          placeId: results[0].place_id,
          addressComponents: results[0].address_components,
        });

        const newResponse = {
          location: newLoc,
          fullAddress: String(results[0].formatted_address),
        };

        return new Promise(function(resolve, reject) {
          resolve(newResponse);
        });
      }
    } else
      return new Promise(function(resolve, reject) {
        resolve(null);
      });
  };

  getGoogleMapsData(data: LocationGeo): Location | null {
    if (data) {
      let newValue: Location = {
        lat: String(data.location.lat),
        lng: String(data.location.lng),
        placeId: data.placeId,
        address1: '',
        admin1: '',
        admin2: '',
      };

      data.addressComponents.forEach(component => {
        if (component.types.indexOf('postal_code') !== -1)
          newValue.zipCode = component.long_name;
        if (component.types.indexOf('country') !== -1)
          newValue.country = component.short_name;
        if (component.types.indexOf('administrative_area_level_1') !== -1)
          newValue.admin1 = component.long_name;
        if (component.types.indexOf('administrative_area_level_2') !== -1)
          newValue.admin2 = component.long_name;
        if (component.types.indexOf('locality') !== -1)
          newValue.admin3 = component.long_name;
        if (component.types.indexOf('route'))
          newValue.admin4 = component.long_name;
        if (component.types.indexOf('street_number') !== -1)
          newValue.admin5 = component.long_name;
      });
      return newValue;
    }

    return null;
  }

  getPlaceId = (placeId: string): Promise<any> => {
    return getPlaceIdApi({
      provider: 'GOOGLE_MAPS',
      place_id: placeId,
      session_token: this.sessionToken ? this.sessionToken.Fm : '',
    }).toPromise();
  };

  formatLocation = (location: {[key: string]: string}): Location => {
    return {
      address1: location.address1,
      address2: location.address2 || undefined,
      lat: location.lat || '',
      lng: location.lng || '',
      admin1: location.admin1,
      admin2: location.admin2,
      admin3: location.admin3 || undefined,
      admin4: location.admin4 || undefined,
      admin5: location.admin5 || undefined,
      admin6: location.admin6 || undefined,
      zipCode: location.zipCode || undefined,
      country: location.country || undefined,
      placeId: location.placeId || undefined,
    };
  };
}
